import {Realm} from "../environment/realm/realm";

export function $Int16ArrayPrototype$(realm: Realm) {
	return realm["[[GlobalObject]]"].Int16Array.prototype;
}
